// A door is a window opening with sill = 0 (see backend/docs/TODO.md's
// "Doors" note and windowOpening.ts's original TODO(doors) comment): same
// Facet-region model, no new geometry class. This file is the ONE place the
// sill=0 invariant is enforced — every door mutation point must route
// through `syncDoorGeometry`, never bare `syncWindowGeometry`.

import { type WindowGeom, syncWindowGeometry } from './windowGeom';

/** Acoustic catalog key for a closed solid-wood door. Must match the
 *  `door_wood_solid` key added to `backend/materials.py`'s `WALL_MATERIALS`. */
export const DOOR_MATERIAL_DEFAULT = 'door_wood_solid';

/** Typical solid interior door slab thickness, metres. */
export const DOOR_THICKNESS_DEFAULT_M = 0.045;

/** Single-leaf standard door width, metres (~36"). */
export const DOOR_STANDARD_WIDTH_M = 0.9;

/** Standard door height, metres (~80"). */
export const DOOR_STANDARD_HEIGHT_M = 2.03;

/** Double-leaf door width, metres (two ~0.8 m leaves). */
export const DOOR_DOUBLE_WIDTH_M = 1.6;

/**
 * Fills in door defaults (mirrors `syncWindowGeometry`) and unconditionally
 * pins the sill to the floor: `v = h / 2`, always, regardless of what the
 * caller passed in `v`. Doors never get a custom-shape editor, so any
 * `polygon` is ignored/dropped here — a door is always treated as a plain
 * rectangle from (u, v, w, h).
 */
export function syncDoorGeometry<T extends WindowGeom>(
  door: T,
): T & { thickness: number; material: string } {
  return syncWindowGeometry({
    ...door,
    polygon: undefined,
    v: door.h / 2,
    thickness: door.thickness ?? DOOR_THICKNESS_DEFAULT_M,
    material: door.material ?? DOOR_MATERIAL_DEFAULT,
  });
}
